export const CERTIFICATE_TYPE = {
  DRIVER_LICENSE: 'driver_license',
  PASSPORT: 'passport',
  MY_NUMBER: 'my_number',
  RESIDENCE_CARD: 'residence_card',
};

export const PROVIDER_TYPE = {
  GOOGLE_AUTH2: 'google_oauth2',
  FACEBOOK: 'facebook',
  LINE: 'line',
  ONE: 'one',
};

export const APP_VIEW = 'app_view';

export type ProviderType = typeof PROVIDER_TYPE[keyof typeof PROVIDER_TYPE];

// urls
export const KYOTANGO_PCR_NEWS_URL = 'https://otetsutabi.com/news/152';
